import { DateTime } from 'luxon';
import { atomWithStorage } from 'jotai/utils';

const tz = 'America/New_York';

export type GraphRangeLabel =
  | 'Last 1 hour'
  | 'Last 6 hours'
  | 'Last 12 hours'
  | 'Last 24 hours'
  | 'Yesterday'
  | 'Last 3 days'
  | 'Last 7 days'
  | 'Last 30 days'
  | 'Custom';

export type SharedGraphTimeRangeState = {
  selectedRange: GraphRangeLabel;
  startISO: string;
  endISO: string;
};

function defaultState(): SharedGraphTimeRangeState {
  const now = DateTime.now().setZone(tz);
  return {
    selectedRange: 'Last 24 hours',
    startISO: now.minus({ hours: 24 }).toISO() ?? now.minus({ hours: 24 }).toString(),
    endISO: now.toISO() ?? now.toString(),
  };
}

// Namespaced storage key so it doesn't clash with anything else in GolfTrack.
export const sharedGraphTimeRangeAtom = atomWithStorage<SharedGraphTimeRangeState>(
  'fpm.graphTimeRange:v1',
  defaultState()
);
